@if (activeEditorIndex === 0) {
  <div>
    <form [formGroup]="form">
      <div class="batch-form">
        <div class="form-group">
          <span class="label">Subject:</span>
          <input type="hidden" formControlName="subject" />
          <app-wysiwyg
            #SubjectWysiwyg
            [showPlaceholders]="true"
            [showToolbarItems]="false"
            (valueChanged)="
              wysiwygChange.next({ field: 'subject', value: $event })
            "
            class="form-control floating-header no-padding"
            [class.has-error]="!form.controls.subject.valid"
          >
          </app-wysiwyg>
        </div>
        <div class="form-group form-group--message">
          <span class="label">Message:</span>
          <input type="hidden" formControlName="message" />
          <app-wysiwyg
            #MessageWysiwyg
            [value]="wysiwygText"
            [showPlaceholders]="true"
            [showToolbarItems]="true"
            (valueChanged)="
              wysiwygChange.next({ field: 'message', value: $event })
            "
            class="form-control no-padding"
            [class.has-error]="!form.controls.message.valid"
          >
          </app-wysiwyg>
        </div>
        <div class="form-group">
          <span class="label">File:</span>
          <input type="hidden" formControlName="attachment" />
          <app-upload
            [showUploadedFile]="true"
            (fileUploaded)="setAttachment($event)"
          >
          </app-upload>
        </div>
      </div>
    </form>
  </div>
}
